import { render } from "./CardImage.vue?vue&type=template&id=0dfffcd4&scoped=true"
import script from "./CardImage.vue?vue&type=script&lang=js"
export * from "./CardImage.vue?vue&type=script&lang=js"

import "./CardImage.vue?vue&type=style&index=0&id=0dfffcd4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dfffcd4"]])

export default __exports__